import React from "react";

import { SupportCodeModal } from "@pages/Applications/DeviceAssociateModal/MoneticsApplicationForm/SupportCodeModal";

import { ConfirmationActiveFidelity } from "../ConfirmationActiveFidelity";
import HistoryModal from "../HistoryModal";
import InformationFidelity from "../InformationFidelity";

import { FidelityAssociateModalWrapper } from "./FidelityAssociateModalWrapper";

type Props = {
    // Support code
    isModalOpenedSupport: boolean;
    setIsModalOpenedSupport: (v: boolean) => void;
    codeSupport: string;
    setCodeSupport: (v: string) => void;
    isValidCode: boolean;
    setIsValidCode: (v: boolean) => void;

    // Active fidelity
    isModalOpened: boolean;
    setIsModalOpened: (v: boolean) => void;

    // History
    isHistoryModalOpened: boolean;
    setIsHistoryModalOpened: (v: boolean) => void;

    // Associate
    isAssociateModalOpened: boolean;
    selectedRows: any[];
    setGlobalDataIsUpdated: (v: boolean) => void;
    setLimit: (v: number) => void;

    // Consult
    isConsultModalOpened: boolean;
};

export default function ShopsFidelityModals({
    isModalOpenedSupport,
    setIsModalOpenedSupport,
    codeSupport,
    setCodeSupport,
    isValidCode,
    setIsValidCode,
    isModalOpened,
    setIsModalOpened,
    isHistoryModalOpened,
    setIsHistoryModalOpened,
    isAssociateModalOpened,
    selectedRows,
    setGlobalDataIsUpdated,
    setLimit,
    isConsultModalOpened,
}: Props) {
    return (
        <React.Fragment>
            <ConfirmationActiveFidelity
                setIsModalOpened={setIsModalOpened}
                isModalOpened={isModalOpened}
            />
            {isHistoryModalOpened ? (
                <HistoryModal
                    setIsModalOpened={setIsHistoryModalOpened}
                    isModalOpened={isHistoryModalOpened}
                    setDataUpdated={setGlobalDataIsUpdated}
                />
            ) : null}
            {isAssociateModalOpened ? (
                <FidelityAssociateModalWrapper
                    setData={setGlobalDataIsUpdated}
                    selectedShopsRows={selectedRows}
                    setLimit={setLimit}
                />
            ) : null}
            {isConsultModalOpened ? (
                <InformationFidelity
                    selectedShopsRows={selectedRows}
                    setGlobalDataIsUpdated={setGlobalDataIsUpdated}
                />
            ) : null}
            {isModalOpenedSupport ? (
                <SupportCodeModal
                    isModalOpened={isModalOpenedSupport}
                    setIsModalOpened={setIsModalOpenedSupport}
                    codeSupport={codeSupport}
                    setCodeSupport={setCodeSupport}
                    isValidCode={isValidCode}
                    setIsValidCode={setIsValidCode}
                />
            ) : null}
        </React.Fragment>
    );
}
